import React, { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import {
  convertStringToArray,
  extractDate,
  extractDateFromStr,
  getLatestDateFromData,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import Loader from "../../components/Loader";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const OthersPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: otherData = [], isLoading: otherIsLoading } =
    useGetProtectedApiDataQuery({
      url: "other",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(() => {
    return getLatestDateFromData(otherData);
  }, [otherData]);

  useTableResponsive(otherData);

  const pdfArray = convertStringToArray(otherData[0]?.field_other_document);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (otherIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Investors", "निवेशक")}
        titleLink="/investors/others"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row mb-2">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Description", "विवरण")}</th>
                        <th>{getText("File", "फ़ाइल")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pdfArray.length > 0 ? (
                        pdfArray.map((item, index) => (
                          <tr key={index}>
                            <td data-key={getText("S.No.", "क्र. सं.")}>
                              {index + 1}
                            </td>
                            <td data-key={getText("Description", "विवरण")}>
                              {item.title}
                            </td>
                            <td data-key={getText("File", "फ़ाइल")}>
                              <PdfZipItem
                                filePath={item?.file_path}
                                filesize={item?.filesize}
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">
                            {getText(
                              "No records found",
                              "कोई रिकॉर्ड नहीं मिला",
                            )}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OthersPage;
